<style src="./RightSidePanel.scss" lang="scss" scoped></style>
<template>
  <aside
    tabindex="0"
    :style="style"
    class="right-side-panel"
    @keyup.esc="closePanel"
    v-shortkey="shortcut" @shortkey="showPanel">
    <transition name="show-panel">
      <section
        v-click-outside="() => outsideClose && closePanel()"
        class="container"
        :class="{ 'add-padding': padding }"
        v-if="showContent">

        <span class="panel-title">{{ title }}</span>
        <div class="close-panel">
          <icon-close @click.native="closePanel"/>
        </div>

        <slot />
        <div
          v-if="!outsideClose"
          class="overflow"></div>
      </section>
    </transition>
  </aside>
</template>

<script>
import { IconClose } from '@/components/primitives/icons'

export default {
  name: 'RightSidePanel',
  components: {
    IconClose
  },
  props: {
    title: {
      default: ''
    },
    shortcut: {
      default: false
    },
    padding: {
      default: true
    },
    width: {
      default: '400px'
    },
    outsideClose:
    {
      default: true
    }
  },
  data () {
    return {
      showContent: false
    }
  },
  computed: {
    style () { return `width: ${this.width}; right: ${this.width};` }
  },
  mounted () {
    this.$on('close', (pRefreshList = false) => { this.closePanel(pRefreshList) })
  },
  methods: {
    closePanel (pRefreshList) {
      this.showContent = false
      this.$emit('close-panel', pRefreshList)
    },
    showPanel () {
      this.showContent = true
      this.$nextTick(() => {
        this.$el.focus()
      })
      this.$emit('show-panel')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/foundation/right-side-panel/RightSidePanel.vue